module.exports = __webpack_public_path__ + "assets/img/ee5d8156d91713696e5bd5999ba70ce3.png";